import React from 'react';
import fr from 'facet-rest';
import { WorkflowLayout } from 'Components/ComponentLibrary/Organisms/WorkflowLayout/WorkflowLayout';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  FDContentContainer, FDPrimaryActionButton, FDSecondaryActionButton, FDStack, FDTextButton,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { dataAttrs } from 'Helpers/Testing';
import { WizardBackButtonRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/WizardBackButtonRel';

export const AccountOpeningV2BeneficiaryIntroStepLayout = () => {
  const { resource, onSubmit, saving } = useMetaLayoutContext();
  const { loadPageContentLink } = usePageContentContext();
  const beneficiaryMetaOptions = resource.meta().field('beneficiaries')?.options();
  const hasBeneficiaries = beneficiaryMetaOptions ? beneficiaryMetaOptions.length() > 0 : false;

  const AddBeneficiaryComponent = hasBeneficiaries ? FDSecondaryActionButton : FDPrimaryActionButton;
  const SubmitButtonComponent = hasBeneficiaries ? FDPrimaryActionButton : FDTextButton;

  return (
    <WorkflowLayout appearance={'elevated'}>
      <FDContentContainer maxWidth="sm">
        <FDStack direction={'column'} spacing={8} alignItems={'center'}>
          <FDStack direction={'column'} spacing={2} alignSelf={'flex-start'}>
            <MetaControlField attr={'title'} />
            <MetaControlField attr={'description'} />
            <MetaControlField attr={'beneficiaries'} />
            {resource.withRelationship(fr.relationships.addBeneficiary.name, (rel) => {
              return (
                <AddBeneficiaryComponent
                  {...dataAttrs('add-btn', resource)}
                  icon="add"
                  label={rel.meta('prompt')}
                  onClick={() => loadPageContentLink(rel.link('related'))}
                  alignSelf="center"
                />
              );
            }, () => null)}
          </FDStack>
          <FDStack alignItems="center" direction="column" spacing={2}>
            <FDStack alignItems={'center'} spacing={2} justifyContent={'center'}>
              <WizardBackButtonRel overrideOnClick={(_, rel) => loadPageContentLink(rel.link('related'))} resource={resource} />
              {resource.meta().canSubmit() ? <SubmitButtonComponent
                size={'md'}
                {...dataAttrs('continue-btn', resource)}
                loading={saving}
                label={resource.attr('primaryActionLabel')}
                onClick={() => onSubmit()}
              /> : null}
            </FDStack>
          </FDStack>
        </FDStack>
      </FDContentContainer>
    </WorkflowLayout>
  );
};
